module.exports = __webpack_public_path__ + "img/pencil-create.a1bbb10e.svg";